import type { Theme } from '@mui/material';

export const styles = {
  wrapper: (theme: Theme) => ({
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    backgroundColor: theme.colors.neutral[200],
    position: 'relative',
    color: theme.colors.neutral[600],
    fontWeight: 'normal',
    borderRadius: 0,
    p: 1,

    svg: {
      color: theme.colors.neutral[400],
    },

    '&:hover, &:hover:not(:disabled)': {
      backgroundColor: theme.colors.neutral[200],
    },

    '&:not(:last-child):after': {
      position: 'absolute',
      top: '34%',
      right: 0,
      content: '""',
      height: '32%',
      width: '1px',
      backgroundColor: theme.colors.neutral[400],
    },
  }),

  content: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    overflow: 'hidden',
  },
};
